<template>
  <div class="cash-wrap">
    <v-card class="custome-card" id="bonds_list">
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        id="cash-scroll-table"
        class="custome-table cash-table"
        hide-default-footer
        disable-pagination
        fixed-header
        :height="CompCashHeight"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @click:row="order_sidebar"
      >
        <template v-slot:body.prepend>
          <tr class="table-dropdown sticky-header">
            <td>
              <div class="form-group">
                <v-text-field
                  class="form-control"
                  type="text"
                  hide-details="auto"
                  v-model="search_table.security_name"
                  @change="fetchSecurities(1)"
                ></v-text-field>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-autocomplete
                  v-model="search_table.currency"
                  :items="currency_data"
                  dense
                  filled
                  clearable
                  class="table-input"
                  item-text="text"
                  item-value="value"
                  @change="fetchSecurities(1)"
                >
                </v-autocomplete>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-autocomplete
                  v-model="search_table.second_currency"
                  :items="second_currency_data"
                  dense
                  filled
                  clearable
                  class="table-input"
                  item-text="text"
                  item-value="value"
                  @change="fetchSecurities(1)"
                >
                </v-autocomplete>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-autocomplete
                  v-model="search_table.country"
                  :items="countries_data"
                  dense
                  filled
                  clearable
                  class="table-input"
                  item-text="text"
                  item-value="value"
                  @change="fetchSecurities(1)"
                >
                </v-autocomplete>
              </div>
            </td>

            <td>
              <div class="form-group">
                <v-autocomplete
                  v-model="search_table.second_country"
                  :items="sec_countries_data"
                  dense
                  filled
                  clearable
                  class="table-input"
                  item-text="text"
                  item-value="value"
                  @change="fetchSecurities(1)"
                >
                </v-autocomplete>
              </div>
            </td>
            <!-- <td>
                  <div class="form-group">
                    <v-autocomplete
                      v-model="search_table.ticker"
                      :items="ticker_data"
                      dense
                      filled
                      clearable
                      class="table-input"
                      item-text="text"
                      item-value="value"
                      @change="fetchSecurities(1)"
                    >
                    </v-autocomplete>
                  </div>
                </td> -->
            <td>
              <div class="form-group">
                <v-text-field
                  class="form-control"
                  type="text"
                  hide-details="auto"
                  v-model="search_table.bid_size"
                ></v-text-field>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-text-field
                  class="form-control"
                  type="text"
                  hide-details="auto"
                  v-model="search_table.bid_price"
                ></v-text-field>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-text-field
                  class="form-control"
                  type="text"
                  hide-details="auto"
                  v-model="search_table.spread"
                ></v-text-field>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-text-field
                  class="form-control"
                  type="text"
                  hide-details="auto"
                  v-model="search_table.ask_price"
                ></v-text-field>
              </div>
            </td>
            <td>
              <div class="form-group">
                <v-text-field
                  class="form-control"
                  type="text"
                  hide-details="auto"
                  v-model="search_table.ask_size"
                ></v-text-field>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:body.append>
          <tr class="view-more-tr" v-if="allowViewMore">
            <td colspan="10">
              <a @click="fxSpotOrderForm()">View More</a>
            </td>
          </tr>
        </template>
        <template v-slot:[`item.security_name`]="{ item }">
          <span class="teble-ellipsis-wrap security-name-wrap">
            {{ item.security_name }}
          </span>
        </template>
        <template v-slot:[`item.bid_size`]="{ item }">
          <span>
            {{ item.bid_size }}
          </span>
        </template>
        <template v-slot:[`item.bid_price`]="{ item }">
          <span
            class="td-values bid-price"
            :class="item.market_id == 2 ? ' ' : 'hover-td-values'"
          >
            <div
              class="teble-ellipsis-wrap e-w-70 value-none m-auto text-center"
            >
              {{ formatPrice(item.bid_price, item.market_id) }}
            </div>
            <div class="hover-wrap" v-if="item.market_id != 2">
              <template>
                <b-button
                  v-if="is_maximize == 1"
                  @click.stop="order_sidebar(item)"
                  variant="danger"
                  >Sell</b-button
                >
                <b-button
                  v-if="is_maximize == 0"
                  @click="selectItem(item, '1')"
                  variant="danger"
                  >Sell</b-button
                >
              </template>
            </div>
          </span>
        </template>
        <template v-slot:[`item.spread`]="{ item }">
          <span>
            {{ formatPrice(item.spread, item.market_id, 2) }}
          </span>
        </template>
        <template v-slot:[`item.ask_price`]="{ item }">
          <span
            class="td-values ask-price"
            :class="item.market_id == 2 ? ' ' : 'hover-td-values'"
          >
            <div
              class="teble-ellipsis-wrap e-w-70 value-none m-auto text-center"
            >
              {{ formatPrice(item.ask_price, item.market_id) }}
            </div>
            <div class="hover-wrap" v-if="item.market_id != 2">
              <template>
                <b-button
                  v-if="is_maximize == 1"
                  @click.stop="order_sidebar(item)"
                  variant="success"
                  >Buy</b-button
                >
                <b-button
                  v-if="is_maximize == 0"
                  @click="selectItem(item, '1')"
                  variant="success"
                  >Buy</b-button
                >
              </template>
            </div>
          </span>
        </template>

        <template v-slot:[`item.ask_size`]="{ item }">
          <span>
            {{ item.ask_size }}
          </span>
        </template>
      </v-data-table>
    </v-card>
    <div
      class="grid-view d-none"
      :style="{ height: CompCashHeight + 'px' }"
      id="grid_bonds_list"
    >
      <b-row>
        <b-col sm="4" lg="3" v-for="list_item in items" :key="list_item.id">
          <v-card>
            <v-card-title>{{ list_item.security_name }}</v-card-title>
            <v-card-text>
              <div class="grid-buttons">
                <b-button
                  @click.stop="order_sidebar(list_item)"
                  variant="danger"
                >
                  <span>Sell</span>
                  <p>
                    {{ gridFirstPrice(list_item.bid_price) }}
                    <span>{{ gridSecondPrice(list_item.bid_price, 4, 5) }}</span
                    ><span>{{
                      gridSecondPrice(list_item.bid_price, 5, 6)
                    }}</span
                    ><span>{{
                      gridSecondPrice(list_item.bid_price, 6, 7)
                    }}</span>
                  </p>
                </b-button>

                <b-button
                  @click.stop="order_sidebar(list_item)"
                  variant="success"
                >
                  <span class="text-right">Buy</span>
                  <p class="text-right">
                    {{ gridFirstPrice(list_item.ask_price) }}

                    <span>{{ gridSecondPrice(list_item.ask_price, 4, 5) }}</span
                    ><span>{{
                      gridSecondPrice(list_item.ask_price, 5, 6)
                    }}</span
                    ><span>{{
                      gridSecondPrice(list_item.ask_price, 6, 7)
                    }}</span>
                  </p>
                </b-button>

                <div class="margin-price">{{ list_item.spread }}</div>
              </div>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col sm="4" lg="3">
          <v-card class="view-more-btn" v-if="allowViewMore">
            <v-card-text>
              <a @click="fxSpotOrderForm()">View More</a>
            </v-card-text>
          </v-card>
        </b-col>
      </b-row>
    </div>
    <transition name="fade">
      <div class="loading full-page" v-show="loading">
        <div><span></span><span></span><span></span><span></span></div>
      </div>
    </transition>
    <template>
      <v-navigation-drawer
        class="order-form-sidebar"
        width="26%"
        v-model="drawer"
        absolute
        temporary
        right
      >
        <div class="height-50 bb-4 align-items-start">
          <TickerDetails formName="fxspot_order_form" CompisTickerDetailsOpen='true'/>
        </div>
        <div class="height-50" v-if="is_maximize == 1 && active_tab=='Currencies'">
          <SideBarTradingChart ChartOrigin="Cash" CompisTradingChartOpen='isTradingChartOpen' :TraddingChartHeight="400" :TraddingChartWidth="300" v-if="isTradingChartOpen"/>
        </div>
      </v-navigation-drawer>
      <a class="filter-sticky-icon rightside" @click="opensidebarDrawer()">
        <img alt="filter icon" src="@/assets/images/right-arrow.png" />
      </a>
    </template>
    <template>
      <v-navigation-drawer
        class="filter-sidebar"
        width="26%"
        v-model="ScannerDrawer"
        absolute
        temporary
      >
        <div class="sidebar-header">
          <h3>Scanner ({{ total_record }})</h3>
          <a class="cancle-btn" @click="clearScanner()">Clear all</a>
        </div>
        <form>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.currency_oprator"
              :items="text_oprator_list"
              dense
              filled
              class="form-control single-select"
              item-text="text"
              item-value="value"
              label="Operator"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.currency_val"
              :items="currency_data"
              dense
              chips
              deletable-chips
              small-chips
              label="Currencies 1"
              multiple
              item-text="text"
              item-value="value"
              class="form-control multi-select"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.currency_2_oprator"
              :items="text_oprator_list"
              dense
              filled
              class="form-control single-select"
              item-text="text"
              item-value="value"
              label="Operator"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.currency_2_val"
              :items="second_currency_data"
              dense
              chips
              deletable-chips
              small-chips
              label="Currencies 2"
              multiple
              item-text="text"
              item-value="value"
              class="form-control multi-select"
            ></v-autocomplete>
          </div>

          <div class="form-group">
            <v-autocomplete
              v-model="search_table.country_oprator"
              :items="text_oprator_list"
              dense
              filled
              class="form-control single-select"
              item-text="text"
              item-value="value"
              label="Operator"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.country_val"
              :items="countries_data"
              dense
              chips
              deletable-chips
              small-chips
              label="Countries 1"
              multiple
              item-text="text"
              item-value="value"
              class="form-control multi-select"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.country_2_oprator"
              :items="text_oprator_list"
              dense
              filled
              class="form-control single-select"
              item-text="text"
              item-value="value"
              label="Operator"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.country_2_val"
              :items="sec_countries_data"
              dense
              chips
              deletable-chips
              small-chips
              label="Countries 2"
              multiple
              item-text="text"
              item-value="value"
              class="form-control multi-select"
            ></v-autocomplete>
          </div>
          <!-- <div class="form-group">
            <v-autocomplete
              v-model="search_table.bid_price_oprator"
              :items="number_oprator_list"
              dense
              filled
              clearable
              class="form-control single-select"
              item-text="text"
              item-value="value"
              label="Operator"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-text-field
              class="form-control"
              type="text"
              hide-details="auto"
              v-model="search_table.bid_price_val"
              label="Bid Price"
            ></v-text-field>
          </div>
          <div class="form-group">
            <v-autocomplete
              v-model="search_table.ask_price_oprator"
              :items="number_oprator_list"
              dense
              filled
              clearable
              class="form-control single-select"
              item-text="text"
              item-value="value"
              label="Operator"
            ></v-autocomplete>
          </div>
          <div class="form-group">
            <v-text-field
              class="form-control"
              type="text"
              hide-details="auto"
              v-model="search_table.ask_price_val"
              label="Ask Price"
            ></v-text-field>
          </div> -->
          <div class="btn-group justify-content-end">
            <a class="submit_portfolio" @click="fetchSecurities(1)">Scan</a>
          </div>
        </form>
      </v-navigation-drawer>
      <a class="filter-sticky-icon" @click="ScannerDrawer = true">
        <img alt="filter icon" src="@/assets/images/right-arrow.png" />
      </a>
    </template>
  </div>
</template>
<script>
import TickerDetails from "@/components/TickerDetails.vue";
import SideBarTradingChart from "@/components/SideBarTradingChart.vue";
export default {
  name: "Cash",
  components: { TickerDetails: TickerDetails,SideBarTradingChart:SideBarTradingChart },
  data() {
    return {
      traddingHeight:397,
      isTradingChartOpen:false,
      dialog: false,
      drawer: null,
      ScannerDrawer: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "security_name",
          width: "12%",
        },
        {
          text: "Currency 1",
          align: "left",
          width: "8%",
          value: "currency",
        },
        {
          text: "Currency 2",
          align: "left",
          width: "8%",
          value: "second_currency",
        },
        {
          text: "Country 1",
          align: "left",
          width: "13%",
          value: "country_name",
        },
        {
          text: "Country 2",
          align: "left",
          width: "13%",
          value: "second_country_name",
        },
        // { text: "Ticker", class:"maxi-name2", align: "center", width: "10%", value: "ticker_name" },
        {
          text: "Bid Size",
          align: "center",
          width: "10%",
          value: "bid_size",
          filter: (value) => {
            if (!this.search_table.bid_size) return true;
            if (value) {
              return String(value).search(this.search_table.bid_size) > -1;
            }
          },
        },
        {
          text: "Bid",
          align: "center",
          width: "10%",
          value: "bid_price",
          filter: (value) => {
            if (!this.search_table.bid_price) return true;
            if (value) {
              return String(value).search(this.search_table.bid_price) > -1;
            }
          },
        },
        {
          text: "Spread",
          align: "center",
          width: "10%",
          value: "spread",
          filter: (value) => {
            if (!this.search_table.spread) return true;
            if (value) {
              return String(value).search(this.search_table.spread) > -1;
            }
          },
        },
        {
          text: "Ask",
          align: "center",
          width: "10%",
          value: "ask_price",
          filter: (value) => {
            if (!this.search_table.ask_price) return true;
            if (value) {
              return String(value).search(this.search_table.ask_price) > -1;
            }
          },
        },
        {
          text: "Ask Size",
          align: "center",
          width: "10%",
          value: "ask_size",
          filter: (value) => {
            if (!this.search_table.ask_size) return true;
            if (value) {
              return String(value).search(this.search_table.ask_size) > -1;
            }
          },
        },
      ],
      search: "",
      loading: false,
      sortBy: "security_name",
      sortDesc: false,
      menu2: false,
      item_details: [],
      is_gridview: 0,
      search_table: {
        security_name: null,
        name_oprator: "equal",
        security_val: null,
        currency_oprator: "equal",
        currency_val: null,
        currency_2_oprator: "equal",
        currency_2_val: null,
        country_oprator: "equal",
        country_val: null,
        country_2_oprator: "equal",
        country_2_val: null,
        bid_price_oprator: "greater_than",
        bid_price_val: 0,
        ask_price_oprator: "greater_than",
        ask_price_val: 0,
      },
      text_oprator_list: [
        { text: "Equal", value: "equal" },
        { text: "Not Equal", value: "not_equal" },
      ],
      number_oprator_list: [
        { text: "Equal", value: "equal" },
        { text: "Not Equal", value: "not_equal" },
        { text: "Greater Than", value: "greater_than" },
        { text: "Less Than", value: "less_than" },
      ],
      allowViewMore: false,
    };
  },
  computed: {
    countries_data() {
      let countries = this.$store.getters["dashboard/getCountriesSecurity"];
      let countries_data = [];
      for (var i in countries) {
        if (countries[i].market_id == "6") {
          countries_data.push({
            text: countries[i].country_name,
            value: countries[i].country_id,
          });
        }
      }
      return countries_data;
    },
    sec_countries_data() {
      let countries = this.$store.getters[
        "dashboard/getSecondCountriesSecurity"
      ];
      let sec_countries_data = [];
      for (var i in countries) {
        if (countries[i].market_id == "6") {
          sec_countries_data.push({
            text: countries[i].country_name,
            value: countries[i].second_country_id,
          });
        }
      }
      return sec_countries_data;
    },
    currency_data() {
      let currencies = this.$store.getters["dashboard/getCurrencySecurity"];
      let currency_data = [];
      for (var i in currencies) {
        if (currencies[i].market_id == "6") {
          currency_data.push({
            text: currencies[i].currency,
            value: currencies[i].currency,
          });
        }
      }
      return currency_data;
    },
    second_currency_data() {
      let currencies = this.$store.getters[
        "dashboard/getSecondCurrencySecurity"
      ];
      let second_currency_data = [];
      for (var i in currencies) {
        if (currencies[i].market_id == "6") {
          second_currency_data.push({
            text: currencies[i].second_currency,
            value: currencies[i].second_currency,
          });
        }
      }
      return second_currency_data;
    },
    ticker_data() {
      let tickers = this.$store.getters["dashboard/getTickerSecurity"];
      let tickers_data = [];
      for (var i in tickers) {
        if (tickers[i].market_id == "6") {
          tickers_data.push({
            text: tickers[i].ticker_name,
            value: tickers[i].ticker_id,
          });
        }
      }
      return tickers_data;
    },
    items() {
      let items = this.$store.getters["cash/getItems"];
      return items;
    },
    default_market_id() {
      return this.$store.getters["cash/getDefaultMarketId"];
    },
    next_page_index() {
      return this.$store.getters["cash/getNextPage"];
    },
    record_length() {
      return this.$store.getters["cash/getLengthRecord"];
    },
    start_record() {
      return this.$store.getters["cash/getStartRecord"];
    },
    active_tab: {
      get() {
        return this.$store.getters["dashboard/getActiveTab"];
      },
    },
    equityItems() {
      let items = this.$store.getters["equities/getItems"];
      return items;
    },
    bondItems() {
      let items = this.$store.getters["bonds/getItems"];
      return items;
    },
    is_maximize: {
      get() {
        return this.$store.getters["dashboard/getIsMaximize"];
      },
    },
    total_record() {
      let total_record = new Intl.NumberFormat("en-US").format(
        this.$store.getters["cash/getTotalRecord"]
      );
      return total_record;
    },
    is_cash_scanner() {
      return this.$store.getters["cash/getIsCashFilter"];
    },
    profiles() {
      return this.$store.getters["dashboard/getProfiles"];
    },
  },
  props: ["CompisCashOpen","CompCashHeight"],
  watch: {
   
    async active_tab(active_tab_name) {
      if (active_tab_name == "Currencies") {
        //await this.cashStreamingActive();
      }
    },
    async CompCashHeight(new_val) {
      if (new_val > 0) {
        this.$store.dispatch("dashboard/updateActiveTab", "Currencies");
        await this.$store.dispatch("dashboard/fetchIsVisibleOrderEntry", 0);
      }
    },
    async is_cash_scanner(is_cash_scanner) {
      var cashClear = document.getElementById("cash-clear-btn");
      if (is_cash_scanner == 1) {
        cashClear.classList.remove("d-none");
      } else {
        cashClear.classList.add("d-none");
      }
    },
    async is_maximize(is_maximize) {
      var gridBondsList = document.getElementById("grid_bonds_list");
      var BondsList = document.getElementById("bonds_list");
      if (is_maximize == 1) {
        this.is_gridview = 1;
        gridBondsList.classList.remove("d-none");
        BondsList.classList.add("d-none");
      } else {
        BondsList.classList.remove("d-none");
        gridBondsList.classList.add("d-none");
      }
    },
    profiles(val){
      this.allowViewMore = false;
      if(val.id != undefined && val.id === 2){
        this.allowViewMore = true;
      }
    }
  },
  methods: {
    opensidebarDrawer(){
      // console.log("call opensidebarDrawer :: component mounted");
      this.drawer = this.drawer ? false :true;
      this.isTradingChartOpen= true;
    },
    async successAlert(msg) {
      this.$swal({
        title: "",
        showCancelButton: false,
        text: msg,
      });
    },
    async gridView() {
      var gridBondsList = document.getElementById("grid_bonds_list");
      var BondsList = document.getElementById("bonds_list");
      if (this.is_gridview == 1) {
        this.is_gridview = 0;
        document.getElementById("grid-change-btn").innerHTML =
          '<svg width="21px" height="20px" title="List View" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Dribbble-Light-Preview" transform="translate(-219.000000, -200.000000)" fill="#000000"><g id="icons" transform="translate(56.000000, 160.000000)"><path fill="currentColor" d="M181.9,54 L179.8,54 C178.63975,54 177.7,54.895 177.7,56 L177.7,58 C177.7,59.105 178.63975,60 179.8,60 L181.9,60 C183.06025,60 184,59.105 184,58 L184,56 C184,54.895 183.06025,54 181.9,54 M174.55,54 L172.45,54 C171.28975,54 170.35,54.895 170.35,56 L170.35,58 C170.35,59.105 171.28975,60 172.45,60 L174.55,60 C175.71025,60 176.65,59.105 176.65,58 L176.65,56 C176.65,54.895 175.71025,54 174.55,54 M167.2,54 L165.1,54 C163.93975,54 163,54.895 163,56 L163,58 C163,59.105 163.93975,60 165.1,60 L167.2,60 C168.36025,60 169.3,59.105 169.3,58 L169.3,56 C169.3,54.895 168.36025,54 167.2,54 M181.9,47 L179.8,47 C178.63975,47 177.7,47.895 177.7,49 L177.7,51 C177.7,52.105 178.63975,53 179.8,53 L181.9,53 C183.06025,53 184,52.105 184,51 L184,49 C184,47.895 183.06025,47 181.9,47 M174.55,47 L172.45,47 C171.28975,47 170.35,47.895 170.35,49 L170.35,51 C170.35,52.105 171.28975,53 172.45,53 L174.55,53 C175.71025,53 176.65,52.105 176.65,51 L176.65,49 C176.65,47.895 175.71025,47 174.55,47 M167.2,47 L165.1,47 C163.93975,47 163,47.895 163,49 L163,51 C163,52.105 163.93975,53 165.1,53 L167.2,53 C168.36025,53 169.3,52.105 169.3,51 L169.3,49 C169.3,47.895 168.36025,47 167.2,47 M181.9,40 L179.8,40 C178.63975,40 177.7,40.895 177.7,42 L177.7,44 C177.7,45.105 178.63975,46 179.8,46 L181.9,46 C183.06025,46 184,45.105 184,44 L184,42 C184,40.895 183.06025,40 181.9,40 M174.55,40 L172.45,40 C171.28975,40 170.35,40.895 170.35,42 L170.35,44 C170.35,45.105 171.28975,46 172.45,46 L174.55,46 C175.71025,46 176.65,45.105 176.65,44 L176.65,42 C176.65,40.895 175.71025,40 174.55,40 M169.3,42 L169.3,44 C169.3,45.105 168.36025,46 167.2,46 L165.1,46 C163.93975,46 163,45.105 163,44 L163,42 C163,40.895 163.93975,40 165.1,40 L167.2,40 C168.36025,40 169.3,40.895 169.3,42"></path></g></g></g></svg>';
        BondsList.classList.remove("d-none");
        gridBondsList.classList.add("d-none");
      } else {
        this.is_gridview = 1;
        document.getElementById("grid-change-btn").innerHTML =
          '<svg height="1792" viewBox="0 0 1792 1792" width="1792" title="Grid View" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm-1536-1152v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z"/></svg>';
        gridBondsList.classList.remove("d-none");
        BondsList.classList.add("d-none");
      }
    },
    async erroeAlert(msg) {
      this.$swal({
        title: "Oops...",
        text: msg,
      });
    },
    async fetchSecurities(is_filter) {
      this.loading = true;
      await this.$store.dispatch("cash/fetchItems", {
        market_id: this.default_market_id,
        page: this.next_page_index,
        start: this.start_record,
        length: this.record_length,
        is_filter: is_filter,
        security_name: this.search_table.security_name,
        currency: this.search_table.currency,
        second_currency: this.search_table.second_currency,
        second_country: this.search_table.second_country,
        country: this.search_table.country,
        ticker: this.search_table.ticker,
        name_oprator: this.search_table.name_oprator,
        security_val: this.search_table.security_val,
        currency_oprator: this.search_table.currency_oprator,
        currency_val: this.search_table.currency_val,
        currency_2_oprator: this.search_table.currency_2_oprator,
        currency_2_val: this.search_table.currency_2_val,
        country_oprator: this.search_table.country_oprator,
        country_val: this.search_table.country_val,
        country_2_oprator: this.search_table.country_2_oprator,
        country_2_val: this.search_table.country_2_val,
        bid_price_oprator: this.search_table.bid_price_oprator,
        bid_price_val: this.search_table.bid_price_val,
        ask_price_oprator: this.search_table.ask_price_oprator,
        ask_price_val: this.search_table.ask_price_val,
      });
      this.loading = false;
    },
    async fetchFxspotCurrencyList(){
      await this.$store.dispatch("cash/fetchFxspotCurrencyList");
    },
    async clearScanner() {
      this.search_table.security_name = null;
      this.search_table.currency = null;
      this.search_table.second_currency = null;
      this.search_table.country = null;
      this.search_table.second_country = null;
      this.search_table.name_oprator = "equal";
      this.search_table.security_val = null;
      this.search_table.currency_oprator = "equal";
      this.search_table.currency_val = null;
      this.search_table.currency_2_oprator = "equal";
      this.search_table.currency_2_val = null;
      this.search_table.country_oprator = "equal";
      this.search_table.country_val = null;
      this.search_table.country_2_oprator = "equal";
      this.search_table.country_2_val = null;
      this.search_table.bid_price_oprator = "greater_than";
      this.search_table.bid_price_val = 0;
      this.search_table.ask_price_oprator = "greater_than";
      this.search_table.ask_price_val = 0;
      this.ScannerDrawer = false;

      await this.fetchSecurities(1);
    },
    async selectItem(security_items, is_order) {
      let securityId = security_items.id;
      let ib_conid = security_items.ib_conid;
      let iex_symbol = security_items.iex_symbol;
      let market_id = security_items.market_id;
      if (securityId > 0) {
        if (ib_conid != undefined && ib_conid > 0) {
          await this.$store.dispatch("dashboard/updateDefaultSecuritySet", {
            secuirty_id: securityId,
            conid: ib_conid,
            iex_symbol: iex_symbol,
            market_id: market_id,
          });
        }

        if (is_order == "1") {
          await this.$store.dispatch("dashboard/fetchIsVisibleOrderEntry", 1);
        } else {
          await this.$store.dispatch("dashboard/fetchIsVisibleOrderEntry", 0);
        }
        await this.$store.dispatch("chart/updateDefaultChart", {
          security_id: securityId,
        });

        await this.$store.dispatch("chart/updateConId", {
          con_id: ib_conid,
        });
        await this.updateFormQuantity("0");
        await this.loadSecurity(securityId, []);
      }
    },
    async order_sidebar(row_item) {
      if (this.is_maximize == 1) {
        await this.$store.dispatch("dashboard/updateRFQSettings", {
          is_rfq_order: false,
          rfq_form_type: null
        });
        // this.drawer = !this.drawer;
        this.opensidebarDrawer();
      }
      await this.selectItem(row_item, "0");
    },
    async cashStreamingActive() {
      var user_id = localStorage.getItem("login-id");
      var user_name = localStorage.getItem("login-name");
      let securityList = [];
      let cash_list = this.items;
      for (var i in cash_list) {
        if (cash_list[i].market_id == "6") {
          securityList.push({
            security_id: cash_list[i].id,
            conid: cash_list[i].ib_conid,
            user_id,
          });
        }
      }
      var securitySet = {
        security_list: securityList,
        user_id: user_id,
      };
      //console.log("cash_user_join");
      await this.$socket.emit("user_join", { user_id, user_name });
      //console.log("cash_security_subscription", securitySet);
      await this.$socket.emit("security_subscription", securitySet);
    },
    async fxSpotOrderForm(){
      if (this.is_maximize == 1) {
        await this.$store.dispatch("dashboard/updateRFQSettings", {
          is_rfq_order: true,
          rfq_form_type: 'cash'
        });
        // this.drawer = !this.drawer;
        this.opensidebarDrawer();
      }
    },
  },
  async mounted() {
    if(this.CompisCashOpen){
      // console.log("call cash component mounted order");
      await this.fetchSecurities(0);
      await this.fetchFxspotCurrencyList();
      let currenctDom = this;
      setTimeout(() => {
        let grid_btn = document.querySelector("#grid-change-btn");
        if (!grid_btn) {
          var x = document.getElementsByClassName("lm_header");
          for (let i = 0; i < x.length; i++) {
            let isFind = x[i].querySelectorAll("li[title='Currencies']").length;
            if (isFind > 0) {
              var gridBtn = document.createElement("BUTTON");

              gridBtn.innerHTML =
              '<svg width="21px" height="20px" title="List View" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Dribbble-Light-Preview" transform="translate(-219.000000, -200.000000)" fill="#000000"><g id="icons" transform="translate(56.000000, 160.000000)"><path fill="currentColor" d="M181.9,54 L179.8,54 C178.63975,54 177.7,54.895 177.7,56 L177.7,58 C177.7,59.105 178.63975,60 179.8,60 L181.9,60 C183.06025,60 184,59.105 184,58 L184,56 C184,54.895 183.06025,54 181.9,54 M174.55,54 L172.45,54 C171.28975,54 170.35,54.895 170.35,56 L170.35,58 C170.35,59.105 171.28975,60 172.45,60 L174.55,60 C175.71025,60 176.65,59.105 176.65,58 L176.65,56 C176.65,54.895 175.71025,54 174.55,54 M167.2,54 L165.1,54 C163.93975,54 163,54.895 163,56 L163,58 C163,59.105 163.93975,60 165.1,60 L167.2,60 C168.36025,60 169.3,59.105 169.3,58 L169.3,56 C169.3,54.895 168.36025,54 167.2,54 M181.9,47 L179.8,47 C178.63975,47 177.7,47.895 177.7,49 L177.7,51 C177.7,52.105 178.63975,53 179.8,53 L181.9,53 C183.06025,53 184,52.105 184,51 L184,49 C184,47.895 183.06025,47 181.9,47 M174.55,47 L172.45,47 C171.28975,47 170.35,47.895 170.35,49 L170.35,51 C170.35,52.105 171.28975,53 172.45,53 L174.55,53 C175.71025,53 176.65,52.105 176.65,51 L176.65,49 C176.65,47.895 175.71025,47 174.55,47 M167.2,47 L165.1,47 C163.93975,47 163,47.895 163,49 L163,51 C163,52.105 163.93975,53 165.1,53 L167.2,53 C168.36025,53 169.3,52.105 169.3,51 L169.3,49 C169.3,47.895 168.36025,47 167.2,47 M181.9,40 L179.8,40 C178.63975,40 177.7,40.895 177.7,42 L177.7,44 C177.7,45.105 178.63975,46 179.8,46 L181.9,46 C183.06025,46 184,45.105 184,44 L184,42 C184,40.895 183.06025,40 181.9,40 M174.55,40 L172.45,40 C171.28975,40 170.35,40.895 170.35,42 L170.35,44 C170.35,45.105 171.28975,46 172.45,46 L174.55,46 C175.71025,46 176.65,45.105 176.65,44 L176.65,42 C176.65,40.895 175.71025,40 174.55,40 M169.3,42 L169.3,44 C169.3,45.105 168.36025,46 167.2,46 L165.1,46 C163.93975,46 163,45.105 163,44 L163,42 C163,40.895 163.93975,40 165.1,40 L167.2,40 C168.36025,40 169.3,40.895 169.3,42"></path></g></g></g></svg>';
              //grid view icon
              // '<svg height="1792" viewBox="0 0 1792 1792" width="1792" title="Grid View" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm-1536-1152v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z"/></svg>';
                // '<svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm-1536-1152v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z"/></svg>';
              // '<svg width="21px" height="20px" viewBox="0 0 21 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Dribbble-Light-Preview" transform="translate(-219.000000, -200.000000)" fill="#000000"><g id="icons" transform="translate(56.000000, 160.000000)"><path fill="currentColor" d="M181.9,54 L179.8,54 C178.63975,54 177.7,54.895 177.7,56 L177.7,58 C177.7,59.105 178.63975,60 179.8,60 L181.9,60 C183.06025,60 184,59.105 184,58 L184,56 C184,54.895 183.06025,54 181.9,54 M174.55,54 L172.45,54 C171.28975,54 170.35,54.895 170.35,56 L170.35,58 C170.35,59.105 171.28975,60 172.45,60 L174.55,60 C175.71025,60 176.65,59.105 176.65,58 L176.65,56 C176.65,54.895 175.71025,54 174.55,54 M167.2,54 L165.1,54 C163.93975,54 163,54.895 163,56 L163,58 C163,59.105 163.93975,60 165.1,60 L167.2,60 C168.36025,60 169.3,59.105 169.3,58 L169.3,56 C169.3,54.895 168.36025,54 167.2,54 M181.9,47 L179.8,47 C178.63975,47 177.7,47.895 177.7,49 L177.7,51 C177.7,52.105 178.63975,53 179.8,53 L181.9,53 C183.06025,53 184,52.105 184,51 L184,49 C184,47.895 183.06025,47 181.9,47 M174.55,47 L172.45,47 C171.28975,47 170.35,47.895 170.35,49 L170.35,51 C170.35,52.105 171.28975,53 172.45,53 L174.55,53 C175.71025,53 176.65,52.105 176.65,51 L176.65,49 C176.65,47.895 175.71025,47 174.55,47 M167.2,47 L165.1,47 C163.93975,47 163,47.895 163,49 L163,51 C163,52.105 163.93975,53 165.1,53 L167.2,53 C168.36025,53 169.3,52.105 169.3,51 L169.3,49 C169.3,47.895 168.36025,47 167.2,47 M181.9,40 L179.8,40 C178.63975,40 177.7,40.895 177.7,42 L177.7,44 C177.7,45.105 178.63975,46 179.8,46 L181.9,46 C183.06025,46 184,45.105 184,44 L184,42 C184,40.895 183.06025,40 181.9,40 M174.55,40 L172.45,40 C171.28975,40 170.35,40.895 170.35,42 L170.35,44 C170.35,45.105 171.28975,46 172.45,46 L174.55,46 C175.71025,46 176.65,45.105 176.65,44 L176.65,42 C176.65,40.895 175.71025,40 174.55,40 M169.3,42 L169.3,44 C169.3,45.105 168.36025,46 167.2,46 L165.1,46 C163.93975,46 163,45.105 163,44 L163,42 C163,40.895 163.93975,40 165.1,40 L167.2,40 C168.36025,40 169.3,40.895 169.3,42"></path></g></g></g></svg>';

              // List view icon

              //  gridBtn.innerHTML =

              //gridBtn.classList = "btn btn-grid btn-kill-all";
              gridBtn.classList = "btn btn-grid btn-kill-all";
              gridBtn.id = "grid-change-btn";
              x[i].appendChild(gridBtn);
              gridBtn.onclick = async function() {
                await currenctDom.gridView();
              };

              var filterClearBtn = document.createElement("BUTTON");
              filterClearBtn.innerHTML =
                ' <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M 1 0 C 0.448 0 0 0.448 0 1 L 0 4 C 0 4.255 0.10625 4.5015 0.28125 4.6875 L 14.6875 20 L 29.3125 20 L 43.71875 4.6875 C 43.75375 4.6505 43.7845 4.6035 43.8125 4.5625 C 43.8555 4.4995 43.9095 4.447 43.9375 4.375 C 43.9665 4.301 43.95775 4.203 43.96875 4.125 C 43.97575 4.077 44 4.049 44 4 L 44 1 C 44 0.448 43.553 0 43 0 L 1 0 z M 16 22 L 16 39 C 16 39.352 16.199 39.66375 16.5 39.84375 L 26.5 45.84375 C 26.659 45.93875 26.822 46 27 46 C 27.17 46 27.347 45.962 27.5 45.875 C 27.814 45.697 28 45.36 28 45 L 28 22 L 16 22 z M 32.90625 31.96875 A 1.0001 1.0001 0 0 0 32.78125 32 A 1.0001 1.0001 0 0 0 32.28125 33.71875 L 39.5625 41 L 32.28125 48.28125 A 1.016466 1.016466 0 1 0 33.71875 49.71875 L 41 42.4375 L 48.28125 49.71875 A 1.016466 1.016466 0 1 0 49.71875 48.28125 L 42.4375 41 L 49.71875 33.71875 A 1.0001 1.0001 0 0 0 48.875 32 A 1.0001 1.0001 0 0 0 48.28125 32.28125 L 41 39.5625 L 33.71875 32.28125 A 1.0001 1.0001 0 0 0 32.90625 31.96875 z"/></svg>';
              filterClearBtn.classList = "filter-button cash-filter-btn d-none";
              filterClearBtn.id = "cash-clear-btn";
              x[i].appendChild(filterClearBtn);
              filterClearBtn.onclick = async function() {
                await currenctDom.clearScanner();
              };
            }
          }
          // console.log("is_gridview", this.is_gridview);
        }
        
      }, 1000);

      const channel = localStorage.getItem("stream-channel");
      this.sockets.subscribe(channel, (data) => {
        
        console.log("Active Tab: "+this.active_tab);

        if (this.active_tab == "Currencies") {
          let currentIndex = this.items.findIndex(
            (security) => security.id == data.security_id
          );
          //console.log("Cash Index ", currentIndex);
          let security = this.items[currentIndex];

          if (security) {
            security.bid_size = data.bidSize;
            security.bid_price = data.bid;
            security.ask_size = data.askSize;
            security.ask_price = data.ask;
            security.spread = ((data.ask - data.bid) * 10000).toFixed(2);
          }

          this.$store.dispatch("cash/updateItems", this.items);
        } else if (this.active_tab == "Equities") {
          let currentIndex = this.equityItems.findIndex(
            (security) => security.id == data.security_id
          );
          //console.log("Equities Index ", currentIndex);
          let security = this.equityItems[currentIndex];

          if (security) {
            security.bid_size = data.bidSize;
            security.ask_size = data.askSize;
            if (security.country_id == 14) {
              security.bid_size = data.bidSize * 100;
              security.ask_size = data.askSize * 100;
            }
            security.bid_price = data.bid;
            security.ask_price = data.ask;
            security.spread = (data.ask - data.bid).toFixed(2);
          }

          this.$store.dispatch("equities/updateItems", this.equityItems);
        } else if (this.active_tab == "Bonds") {
          let currentIndex = this.bondItems.findIndex(
            (security) => security.id == data.security_id
          );
          //console.log("Bonds Index ", currentIndex);
          let security = this.bondItems[currentIndex];

          if (security) {
            security.bid_size = data.bidSize;
            security.bid_price = data.bid;
            security.ask_size = data.askSize;
            security.ask_price = data.ask;
            security.spread = (data.ask - data.bid).toFixed(2);
          }

          this.$store.dispatch("bonds/updateItems", this.bondItems);
        }
      });
      // Detect when scrolled to bottom.
      // let currenctDom = this;
      // const listElm = document.querySelector("#cash-scroll-table");
      // listElm.addEventListener("scroll", function() {
      //   if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
      //     if (currenctDom.next_page_index != 0) {
      //       currenctDom.fetchSecurities();
      //     }
      //   } else {
      //     this.loading = false;
      //   }
      // });  
    }
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/abstracts/_variables.scss";
@import "@/assets/scss/common/_common.scss";
.cash-wrap {
  padding: 0;
  .teble-ellipsis-wrap {
    width: 110px !important;
  }
  .country_name_w {
    width: 150px !important;
    @media only screen and (max-width: 1799px) {
      width: 100px !important;
    }
  }
  .bid-price {
    color: var(--danger);
  }
  .ask-price {
    color: var(--success);
  }
  #cash-scroll-table {
    overflow: auto;
  }
}
.v-dialog {
  border-radius: 0 !important;
  background: var(--modal-bg);
  .custome-modal {
    &.v-card {
      border-radius: 0;
      background: transparent;
      box-shadow: none !important;
      .v-card__title {
        padding: 10px 15px;
        border-bottom: 1px solid var(--modal-title);
        .box-title {
          width: 100%;
          h4 {
            font-family: var(--font-family);
            font-weight: 500;
            font-size: 18px;
            color: var(--modal-title);
            margin-bottom: 0;
          }
        }
        .table-button-groups {
          .btn {
            height: 30px;
            font-size: 13px !important;
          }
        }
      }
      .v-card__text {
        padding: 0 0 10px;
        ul {
          list-style: none;
          padding: 0 !important;
          margin: 0 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          li {
            width: 100%;
            background-color: transparent !important;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            padding: 5px 8px;
            span {
              &.text-title {
                color: var(--modal-list-text);
                font-size: 13px;
                font-weight: 500;
                width: 40%;
                text-align: left;
              }
              &.text-value {
                color: var(--modal-list-text2);
                text-align: left;
                font-size: 13px;
                font-weight: 500;
              }
            }
            &:nth-of-type(even) {
              background-color: rgba(var(--modal-even-hover-rgba)) !important;
            }
          }
        }
      }

      .v-card__actions {
        border-top: 1px solid var(--modal-title);
        .close-btn {
          color: var(--submit-portfolio-text);
          background-color: var(--submit-portfolio-bg);
          border: 1px solid var(--submit-portfolio-bg);
          line-height: 1;
          display: block;
          margin-bottom: 0;
          font-weight: 400;
          text-align: center;
          cursor: pointer;
          white-space: nowrap;
          padding: 5px 12px;
          font-size: 13px;
          border-radius: 0;
          width: 80px;
          margin: 0;
          height: 30px;
          text-transform: capitalize;
          &:hover,
          &:focus {
            outline: none;
            box-shadow: none;
            color: var(--submit-portfolio-bg);
            background-color: var(--submit-portfolio-text);
            border-color: var(--submit-portfolio-bg) !important;
          }
        }
      }
    }
    .calender-custome {
      .daterangepicker {
        position: relative !important;
        margin: 0;
        display: block !important;
      }
    }
  }
}
#app {
  .cash-wrap {
    .teble-ellipsis-wrap.security-name-wrap {
      @media only screen and (max-width: 1699px) {
        width: 80px !important;
      }
    }
    .custome-table {
      background: transparent !important;
      border-radius: 0;
      border: 0;
      table {
        > tbody {
          > tr {
            td {
              position: relative;
            }
            .hover-wrap {
              position: absolute;
              top: 50%;
              transform: translate(-50%, -50%);
              margin: 0 auto;
              left: 50%;
              right: inherit;
              display: none;
              justify-content: center;
              align-items: center;
              width: 80%;
              padding-right: 0;
              @media only screen and (max-width: 1599px) {
                width: 100%;
              }
              .btn {
                font-size: 14px;
                font-weight: 400;
                height: inherit;
                padding: 1px 6px;
                min-width: inherit;
                width: 85px;
                border-radius: 0;
                line-height: 14px;
                height: 22px;
                margin: 0;
                border: none;
                text-align: center;
                @media only screen and (max-width: 1799px) {
                  width: 75px;
                  font-size: 12px;
                  height: 20px;
                }
                @media only screen and (max-width: 1599px) {
                  width: 65px;
                }
                &:first-child {
                  margin-left: 0;
                }
                &:focus {
                  box-shadow: none;
                  outline: none;
                }
              }
              &:focus {
                box-shadow: none;
                outline: none;
              }
            }
            &:hover,
            &:focus {
              background-color: transparent !important;
              &:nth-of-type(even) {
                background-color: rgba(var(--even-hover-rgba)) !important;
              }
              td {
                color: var(--dark) !important;
                .v-icon {
                  color: var(--dark) !important;
                  &:before {
                    color: var(--dark) !important;
                  }
                }
              }
            }
            &:hover {
              .hover-td-values {
                .value-none {
                  visibility: hidden !important;
                  opacity: 0;
                }
                .hover-wrap {
                  display: flex;
                }
              }
            }
          }
        }
      }
      .v-data-table__wrapper {
        background: transparent;
        border-radius: 0;
        border: 0;
      }
    }
    .grid-view {
      padding: 10px;
      overflow-x: hidden;
      overflow-y: auto;
      @media (min-width: 1699px) {
        .col-lg-3 {
          flex: 0 0 20% !important;
          max-width: 20% !important;
        }
      }
      .v-card {
        cursor: pointer;
        position: relative;
        border-radius: 0;
        border: 1px solid var(--portfolio-hover-text);
        box-shadow: 0 0 6px 2px rgba(var(--primary-rgb), 0.15);
        &.view-more-btn {
          height: 100%;
          .v-card__text {
            height: 100%;
            a {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
              font-size: 28px;
              font-weight: 600;
              color: var(--submit-portfolio-text);
              background-color: var(--submit-portfolio-bg);
              &:hover,
              &:focus {
                outline: none;
                box-shadow: none;
                color: var(--submit-portfolio-bg);
                background-color: var(--submit-portfolio-text);
                border-color: var(--submit-portfolio-bg) !important;
              }
            }
          }
        }
        .v-card__title {
          color: var(--custome-table-thead-text);
          font-size: 13px;
          line-height: 13px;
          font-weight: 600;
          margin-bottom: 0;
          text-align: left;
          height: 27px;
          padding: 0.25rem 0.5rem;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          background: var(--custome-table-thead-bg);
          @media only screen and (min-width: 1799px) {
            font-size: 14px !important;
            line-height: 14px;
          }
          @media only screen and (max-width: 1399px) {
            font-size: 12px !important;
            line-height: 12px;
          }
        }
        .v-card__text {
          padding: 0;
          position: relative;
          background: rgba(var(--v-card-even-hover-rgba));
          .grid-buttons {
            display: flex;
            justify-content: space-between;
            align-content: center;
            position: relative;
            padding: 8px;
            .btn {
              font-size: 14px;
              font-weight: 500;
              height: inherit;
              padding: 12px 16px;
              min-width: inherit;
              width: 48%;
              border-radius: 0;
              line-height: 14px;
              margin: 0;
              border: none;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              &.btn-danger {
                box-shadow: 0 6px 12px rgb(227 29 45 / 18%);
              }
              &.btn-success {
                box-shadow: 0 6px 12px rgb(50 205 50 / 18%);
              }
              p {
                font-size: 13px;
                font-weight: 500;
                line-height: 13px;
                margin-bottom: 0;
                margin-top: 8px;
                min-height: 50px;
                max-height: 50px;
                &.text-right {
                  text-align: right;
                  width: 100%;
                }
                @media only screen and (min-width: 1799px) {
                  font-size: 14px;
                  line-height: 14px;
                }
                @media only screen and (max-width: 1399px) {
                  font-size: 12px;
                  line-height: 12px;
                }
                span {
                  font-size: 50px !important;
                  font-weight: 500;
                  line-height: 50px;
                  @media only screen and (min-width: 1799px) {
                    font-size: 50px !important;
                    line-height: 50px;
                  }
                  @media only screen and (max-width: 1399px) {
                    font-size: 40px !important;
                    line-height: 40px;
                  }
                  &:last-child {
                    font-size: 22px !important;
                    line-height: 50px;
                    vertical-align: text-bottom;
                    @media only screen and (min-width: 1799px) {
                      font-size: 26px !important;
                      line-height: 50px;
                    }
                    @media only screen and (max-width: 1399px) {
                      font-size: 20px !important;
                      line-height: 50px;
                    }
                  }
                }
              }
              > span {
                font-size: 13px;
                font-weight: 500;
                line-height: 14px;
                color: var(--portfolio-hover-text);
                &.text-right {
                  text-align: right;
                  width: 100%;
                }
                @media only screen and (min-width: 1799px) {
                  font-size: 14px !important;
                }
                @media only screen and (max-width: 1399px) {
                  font-size: 12px !important;
                }
              }
              &:focus {
                box-shadow: none;
                outline: none;
              }
            }
            .margin-price {
              position: absolute;
              top: 50%;
              left: 50%;
              -webkit-transform: translate(-50%, -50%);
              -moz-transform: translate(-50%, -50%);
              transform: translate(-50%, -50%);
              background: rgba(var(--margin-price-rgb), 1);
              border: 1px solid var(--margin-price-border);
              box-shadow: 0 6px 12px rgba(var(--margin-price-rgb), 0.18);
              padding: 5px;
              width: 60px;
              height: 30px;
              font-size: 13px;
              font-weight: 600;
              line-height: 1;
              text-transform: capitalize;
              color: var(--white);
              display: flex;
              justify-content: center;
              align-items: center;
              @media only screen and (min-width: 1799px) {
                font-size: 14px !important;
              }
            }
          }
        }
        &:hover {
          .v-card__text {
            .hover-buy-sell-buttons {
              bottom: 0;
              height: auto;
              visibility: visible;
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .lm_maximised {
    .cash-wrap {
      .teble-ellipsis-wrap {
        width: 120px !important;
        &.e-w-70 {
          width: 120px !important;
        }
      }
      .security_w {
        width: 200px !important;
        @media only screen and (min-width: 1699px) {
          width: 320px !important;
        }
      }
    }
  }
}
.cash-table {
  table {
    > thead,
    > tbody {
      > tr {
        > th,
        td {
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6),
          &:last-child {
            display: none;
          }
        }
      }
    }
  }
}
.lm_maximised {
  .cash-table {
    table {
      > thead,
      > tbody {
        > tr {
          > th,
          td {
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6),
            &:last-child {
              display: table-cell;
            }
          }          
        }
      }
    }
  }
}
</style>
